<template>
    <div class="">
        <div style="display: flex;justify-content: space-between;margin-bottom: 20px;">
            <h3># 网艺圈 · 数据总览</h3>
            <div style="display: flex;">
                <el-date-picker placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="pickerData"
                    type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="pickerChange" size="small">
                </el-date-picker>
                <el-button style="margin-left: 10px;" type="primary" plain size="small" @click="searchFn">
                    搜索
                </el-button>
            </div>
        </div>

        <DataPanel :dataVal="tradeAccumulateVal" :titleDataList="titleDataList"></DataPanel>

        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;">
            <div style="width: 48%;cursor: pointer;" @click="toPage('cont')">

                <el-card class="box-card">
                    <div style="height: 400px;overflow: auto;">
                        <h4 style="margin: 20px 0;">
                            # 本周发帖活跃用户
                        </h4>

                        <div style="font-size: 12px;text-align: center;">
                            <span>共计(单位: 条)</span>
                            <span style="margin-left: 10px;color: #F38238;font-size: 14px;">
                                {{ this.allContentCount }}
                            </span>
                        </div>

                        <el-table :data="contentTableData" style="width: 48%">
                            <el-table-column prop="name" label="用户昵称" align="center">
                            </el-table-column>

                            <el-table-column prop="count" label="发贴次数" align="center">
                            </el-table-column>

                            <el-table-column prop="percentage" label="统计百分比" align="center">
                                <template slot-scope="scope">
                                    {{ Number(scope.row.percentage) || 0 }}%
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>

            </div>


            <div style="width: 48%">
                <PriceEchart :rechDataList="rechDataList" :statisticsData="tradeAccumulateVal"></PriceEchart>
            </div>
        </div>

        <h4 style="margin: 20px 0;">
            # 本月用户增长统计
        </h4>

        <div ref="lineChart" style="width: calc(100vw - 330px); height: 289px;">
        </div>
    </div>
</template>

<script>
import DataPanel from './components/data-panel.vue';
import PriceEchart from './components/priceEchart.vue'
import * as echarts from 'echarts'
import { getIndexStatistics, getBoardContentStatistics, getUserStatistics } from '@/api/withdraw'
export default {
    name: '',
    components: {
        DataPanel,
        PriceEchart
    },
    data() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const MM = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        return {
            titleDataList: [
                {
                    title: '注册用户数',
                    key: 'regUserCount',
                    imgUrl: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/288b89194e657603ff40db39e8072640.svg~tplv-49unhts6dw-image.image',
                    pageUrl: '/userHome'
                },
                {
                    title: '申请圈子数量',
                    key: 'circleCount',
                    imgUrl: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/fdc66b07224cdf18843c6076c2587eb5.svg~tplv-49unhts6dw-image.image',
                    pageUrl: '/circle'
                },
                {
                    title: '发帖数量',
                    key: 'contentCount',
                    imgUrl: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/77d74c9a245adeae1ec7fb5d4539738d.svg~tplv-49unhts6dw-image.image',
                    pageUrl: '/content'
                },
                {
                    title: '签到人数',
                    key: 'signCount',
                    imgUrl: '//p3-armor.byteimg.com/tos-cn-i-49unhts6dw/c8b36e26d2b9bb5dbf9b74dd6d7345af.svg~tplv-49unhts6dw-image.image',
                    pageUrl: '/taskLog'
                }
            ],
            rechDataList: [
                { title: '充值金额', key: 'rechargeAmount' },
                { title: '礼物金额', key: 'giftAmount' },
                { title: '礼物平台金额', key: 'platformAmount' },
            ],
            tradeAccumulateVal: {},
            params: { startDate: `${yyyy}-${MM}-${dd}` },
            rawData: [],
            userContDataList: [],
            contentTableData: [],
            allContentCount: 0,
            pickerData: []
        };
    },
    mounted() {
        this.getUserAddDataFn()
    },
    created() {
        this.getDataFn()
        this.getWeekFn()
    },
    methods: {
        // 跳转页面
        toPage(type) {
            if (type == 'cont') {
                this.$router.push('/musterRanking/post')
            }
        },
        searchFn() {
            this.getUserAddDataFn()
            this.getDataFn()
            this.getWeekFn()
        },
        getWeekFn() {
            getBoardContentStatistics(this.params).then(res => {
                if (res.code == 200) {
                    this.allContentCount = res.data.count
                    this.contentTableData = res.data.userStatisticsList || []
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取数据失败')
            })
        },
        pickerChange(val) {
            if (Array.isArray(val) && val.length === 2) {
                this.params.startDate = val[0]
                this.params.endDate = val[1]
            } else {
                const today = new Date()
                const yyyy = today.getFullYear()
                const MM = String(today.getMonth() + 1).padStart(2, '0')
                const dd = String(today.getDate()).padStart(2, '0')
                this.params = { startDate: `${yyyy}-${MM}-${dd}` }
            }
        },
        getUserAddDataFn() {
            getUserStatistics(this.params).then(res => {
                if (res.code == 200) {
                    this.rawData = res.data
                    this.initChart()
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取数据失败')
            })
        },
        getDataFn() {
            getIndexStatistics(this.params).then(res => {
                if (res.code == 200) {
                    this.tradeAccumulateVal = res.data
                } else {
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取数据失败')
            })
        },
        // initChart() {
        //     const myChart = echarts.init(this.$refs.lineChart)

        //     // 1. 全部日期和数据
        //     const xData = this.rawData.map((item, idx) => {
        //         // 只保留偶数位显示，其余给空串
        //         return idx % 2 === 0 ? `${item.day}号` : ''
        //     })
        //     const yData = this.rawData.map(item => item.count)

        //     const option = {
        //         tooltip: { trigger: 'axis' },
        //         grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        //         xAxis: {
        //             type: 'category',
        //             boundaryGap: false,
        //             axisLabel: {
        //                 interval: 0,
        //                 formatter: (_, idx) => xData[idx]
        //             },
        //             data: this.rawData.map(item => `${item.day}号`)
        //         },
        //         yAxis: {
        //             type: 'value',
        //             min: 0,
        //             max: function () {
        //                 const allZero = this.rawData.every(v => v.count === 0)
        //                 return allZero ? 10 : null
        //             }.bind(this),
        //             interval: 5
        //         },
        //         series: [{
        //             name: '新增数量',
        //             type: 'line',
        //             smooth: true,
        //             symbol: 'circle',
        //             symbolSize: 4,
        //             lineStyle: { width: 2, color: '#409eff' },
        //             areaStyle: {
        //                 color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //                     { offset: 0, color: '#6589FF' },
        //                     { offset: 1, color: 'rgba(64, 158, 255, 0.01)' }
        //                 ])
        //             },
        //             data: yData
        //         }]
        //     }

        //     myChart.setOption(option)
        //     window.addEventListener('resize', () => myChart.resize())
        //     this.$once('hook:beforeDestroy', () => {
        //         window.removeEventListener('resize', () => myChart.resize())
        //         myChart.dispose()
        //     })
        // }
        initChart() {
            const myChart = echarts.init(this.$refs.lineChart)

            // 1. 全部日期和数据（保留原有数据处理逻辑）
            const xData = this.rawData.map((item, idx) => {
                // 只保留偶数位显示，其余给空串
                return idx % 2 === 0 ? `${item.day}号` : ''
            })
            const yData = this.rawData.map(item => item.count)

            // 处理 yAxis max 逻辑（提取为独立函数，避免 bind 写法）
            const getYAxisMax = () => {
                const allZero = this.rawData.every(v => v.count === 0)
                return allZero ? 10 : null
            }

            const option = {
                // 沿用原 tooltip 触发方式，替换样式和格式化逻辑
                tooltip: {
                    trigger: 'axis',
                    formatter(params) {
                        const firstElement = params[0];
                        return `<div>
                                    <p class="tooltip-title">${firstElement.axisValueLabel}</p>
                                    <div class="content-panel"><span>新增数量</span><span class="tooltip-value">${Number(firstElement.value).toLocaleString()}</span></div>
                                </div>`;
                    },
                    className: 'echarts-tooltip-diy',
                },
                // 替换 grid 配置为统一风格
                grid: {
                    left: '2.6%',
                    right: '0',
                    top: '10',
                    bottom: '30',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    offset: 2, // 新增统一偏移量
                    axisLabel: {
                        color: '#4E5969', // 统一文字颜色
                        interval: 0,
                        formatter: (_, idx) => xData[idx]
                    },
                    axisLine: {
                        show: false // 隐藏轴线
                    },
                    axisTick: {
                        show: false // 隐藏刻度
                    },
                    splitLine: {
                        show: true,
                        interval: (idx) => {
                            if (idx === 0) return false;
                            if (idx === this.rawData.length - 1) return false;
                            return true;
                        },
                        lineStyle: {
                            color: '#E5E8EF' // 统一分割线颜色
                        }
                    },
                    axisPointer: {
                        show: true,
                        lineStyle: {
                            color: '#23ADFF', // 统一指示器颜色
                            width: 2
                        }
                    },
                    data: this.rawData.map(item => `${item.day}号`)
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    max: getYAxisMax(), // 保留原有逻辑
                    interval: 5,
                    axisLine: {
                        show: false // 隐藏轴线
                    },
                    axisLabel: {
                        formatter(value, idx) {
                            if (idx === 0) return value;
                            return `${value}k`; // 统一单位显示风格
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed', // 统一虚线样式
                            color: '#E5E8EF' // 统一分割线颜色
                        }
                    }
                },
                series: [{
                    name: '新增数量',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 12, // 统一标记大小
                    emphasis: { // 新增高亮样式
                        focus: 'series',
                        itemStyle: {
                            borderWidth: 2
                        }
                    },
                    lineStyle: {
                        width: 3, // 统一线条宽度
                        // 替换为渐变线条颜色
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            { offset: 0, color: 'rgba(30, 231, 255, 1)' },
                            { offset: 0.5, color: 'rgba(36, 154, 255, 1)' },
                            { offset: 1, color: 'rgba(111, 66, 251, 1)' }
                        ])
                    },
                    showSymbol: false, // 隐藏默认标记点
                    areaStyle: {
                        opacity: 0.8, // 统一透明度
                        // 替换为渐变区域颜色
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(17, 126, 255, 0.16)' },
                            { offset: 1, color: 'rgba(17, 128, 255, 0)' }
                        ])
                    },
                    data: yData
                }]
            }

            myChart.setOption(option)
            window.addEventListener('resize', () => myChart.resize())
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', () => myChart.resize())
                myChart.dispose()
            })
        }
    }
};
</script>

<style scoped lang="scss">
.textHidn {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.dataShowInfoCls {
    // text-align: center;
    padding: 20px 0;
    padding-left: 20px;
    width: 100%;
    border: 1px solid #e8eaec;
    cursor: pointer;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    // align-items: center;

    .dataTextHidn {
        font-size: 18px;
        margin-left: 20px;
        word-break: break-all;
    }

    .dataTitleCls {
        font-size: 12px;
        display: flex;
        align-items: center;

        .titleTagCls {
            margin-right: 10px;
            width: 10px;
            height: 10px;
            background: #6589FF;
            border-radius: 50%;
        }
    }
}
</style>
